import {TimeStream} from '../utils';


const defaults = {
    globalIndex: 1,
    popups: [],
	  isPopupInit: false,
    delayPopups: [],
    delayPlayTime: null,
    delayPastTime: null
};


const appendMessage = (state, payload) => {
    /* timestamp 可以维持发送顺序，并保持唯一性 */
    const timestamp = parseFloat(((Date.now() + state.globalIndex * 0.001) * 0.001).toFixed(6));

    var m = {
        id: timestamp,
        type: payload.type,
        account: payload.account,
        timestamp: timestamp,
        create_time: TimeStream(Date.parse(new Date()) / 1000)
    };

    if (m.type === 'discuss_text') {
        m.content = payload.content;
        m.status = 'send';
    }
    return [...state.popups, m];
};


export default (state = defaults, action) => {
    switch (action.type) {
        case 'POPUP_LOAD':
            return {
                ...state,
                popups: action.payload.popups,
                isPopupInit: true,
            };
        case 'POPUP_SEND': {
            const popups = appendMessage(state, action.payload);
            return {...state, popups: popups, globalIndex: state.globalIndex + 1};
        }
        case 'POPUP_TOGGLE': {
            const popups = state.popups.map(m => {
                if (m.id === action.payload.id) {
                    var update = {status: action.payload.status};
                    if (action.payload.message) {
                        update = {...update, ...action.payload.message};
                    }
                    return {...m, ...update};
                }
                return m;
            });
            return {...state, popups: popups};
        }
        case 'POPUP_DELETE': {
            const popups = state.popups.filter(m => m.id !== action.payload.id);
            return {...state, popups: popups};
        }
        case 'POPUP_RECEIVE': {
            action.payload.receive_timestamp = Date.now() * 0.001;
            return {...state, popups: [...state.popups.slice(-20), action.payload]};
        }
        case 'DELAY_POPUP_SHIFT': {
            return {...state, delayPopups: state.delayPopups.slice(1)};
        }
        case 'DELAY_POPUP_LOAD':
            return {
                ...state,
                delayPopups: action.payload.popups,
                delayPlayTime: action.payload.playTime,
                delayPastTime: action.payload.pastTime
            }
        case 'PAGE_INIT':
            return {...state, popups: [], lecture: null};
        default:
            return state;
    }
}





// WEBPACK FOOTER //
// ./src/reducers/popupList.js